import Scene from '@scene';

import {
  SET_REINFORCEMENT_WIDTH,
  SET_REINFORCEMENT_HEIGHT,
  SET_REINFORCEMENT_DEPTH,
  SET_REINFORCEMENT_NZ,
  SET_REINFORCEMENT_TYPE,
  RESET_REINFORCEMENT,
  SET_REINFORCEMENT_OPTIONS,
  SET_REINFORCEMENT_STATE
} from '@reducers/options/reinforcement/actions';
import {mergeDeep} from "../../../services/helper.service";

const initialState = {
  width: {
    active: false,
    value: 1000
  },
  height: {
    active: true,
    value: 300
  },
  depth: {
    active: false,
    value: 200
  },
  actionType: {
    value: 0,
    // unit: 'daN',
    type: '/lm',
    active: true
  }
};

export default (state = mergeDeep({}, initialState), action) => {
  switch (action.type) {
    case RESET_REINFORCEMENT: {
      return mergeDeep({}, initialState);
    }
    case SET_REINFORCEMENT_STATE: {
      return action.state;
    }
    case SET_REINFORCEMENT_WIDTH: {
      state.width.value = action.options.value || state.width.value || initialState.width.value;
      state.width.active = action.options.active !== undefined ? action.options.active : state.width.active;

      Scene.updateReinforcement(state);

      return { ...state };
    }
    case SET_REINFORCEMENT_HEIGHT: {
      state.height.value = action.options.value || state.height.value || initialState.height.value;
      state.height.active = action.options.active !== undefined ? action.options.active : state.height.active;

      Scene.updateReinforcement(state);

      return { ...state };
    }
    case SET_REINFORCEMENT_DEPTH: {
      state.depth.value = action.options.value || state.depth.value || initialState.depth.value;
      state.depth.active = action.options.active !== undefined ? action.options.active : state.depth.active;

      Scene.updateReinforcement(state);

      return { ...state };
    }
    case SET_REINFORCEMENT_NZ: {
      state.actionType.value = action.value;

      Scene.updateReinforcement(state);

      return mergeDeep({}, state);
    }
    case SET_REINFORCEMENT_TYPE: {
      state.actionType.type = action.value;

      Scene.updateReinforcement(state);

      return mergeDeep({}, state);
    }

    case SET_REINFORCEMENT_OPTIONS: {
      const updatedState = mergeDeep({}, state, action.options);
      Scene.updateReinforcement(updatedState);

      return updatedState;
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/reducers/options/reinforcement/index.js